import React from 'react';
import { NotificationsProvider } from '@operoute/ui';

export const wrapPageElement = ({ element }) => {
  return <NotificationsProvider>{element}</NotificationsProvider>;
};
